import { useState, useEffect } from "react";
import {
  HeaderComponent,
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans
} from "@comps/components";
import { makeRequest, removeById } from "@utils/helpers";
import { getAllDataReq, deleteDataReq, updateSaasStatus } from "./requests";
import { Commons, Const } from "../constants";
import { message, Checkbox } from 'antd';
import CreateTenant from "./components/CreateTenant";
import UpdateTenant from "./components/UpdateTenant";
import { Input } from "antd";
import { useSelector } from "react-redux";


// ==================================
//   Page Breadcrumbs Start
// ==================================

const langKey = Const["tenants"].lngKey;

const { Search } = Input;

const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["tenants"].route
      }
    ]
  }
}

// ==================================
//   Page Breadcrumbs End
// ==================================

const IndexTenants = (props) => {

  const authUser = useSelector((state) => state.auth.authUser);
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [related, setRelated] = useState([]);
  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================

  const onChange = (checked, item) => {
    updateSaasStatus(item.uuid, checked)
      .then(res => {
        const obj = dataSource.find(val => val.uuid === res.uuid)
        if (obj !== undefined) {
          obj.active = res.active
        }
      })
      .catch(err => console.error(err))
  }

  const columns = [
    {
      key: trans(`${langKey}.name`),
      title: trans(`${langKey}.name`),
      dataIndex: "tenantId"
    },
    {
      key: trans(`${langKey}.domain`),
      title: trans(`${langKey}.domain`),
      dataIndex: "domain"
    },
    {
      key: trans(`${langKey}.noOfProcess`),
      title: trans(`${langKey}.noOfProcess`),
      dataIndex: "noOfProcess"
    },
    {
      key: trans(`${langKey}.server`),
      title: trans(`${langKey}.server`),
      dataIndex: "server"
    },
    {
      key: trans(`${langKey}.isActive`),
      title: trans(`${langKey}.isActive`),
      dataIndex: "active",
      render: (val, item) => {
        return (
          <Checkbox defaultChecked={ val } onChange={ (e) => onChange(e.target.checked, item) } />
        )
      }
    },
    {
      key: trans(Commons.actions),
      title: trans(Commons.actions),
      render: (record) => (
        <ActionComponent
          each={ record }
          //onDelete={ onDelete }
          onEdit={ onEdit }
        ></ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, []);

  //event
  useEffect(() => {
    getAllData();
  }, []);

  useEffect(() => {
    if (searchKey && searchKey.length > 0) {
      const filteredData = dataSource.filter(item => {
        return item.tenantId.toLowerCase().includes(searchKey.toLowerCase()) ||
          item.server.toLowerCase().includes(searchKey.toLowerCase());
      });
      setFilteredData(filteredData);
      return
    }

    setFilteredData(dataSource);

  }, [dataSource, searchKey]);

  //end event

  const getAllData = () => {
    makeRequest(setLoader, getAllDataReq, null, onSuccess, onError);
  };

  const onSuccess = (response) => {
    setDataSource(response)
  };
  const onError = (err, res) => {
    message.error(res.response.data.message);
  }

  const onCreate = () => {
    setChildComponent(<CreateTenant related={ related } onCompleted={ onCompleted } onSuccess={ onSuccess } />);
  };

  const onEdit = (record) => {
    setChildComponent(
      <UpdateTenant onCompleted={ onCompleted } record={ record } disabled={ false } related={ related } />
    );
  };

  const onView = (record) => {
    setChildComponent(
      <UpdateTenant onCompleted={ onCompleted } record={ record } disabled={ true } related={ related } />
    );
  };

  const onDelete = (record) => {
    makeRequest(setLoader, deleteDataReq, record.id, onDeleted, onError);
  };
  const onDeleted = (res) => {
    onSuccess(res)
    // getAllData();
    setDataSource(removeById(dataSource, res.id));
    message.success("Deleted")
  };

  const onCompleted = (data) => {
    if (data) {
      getAllData()
    }
    setChildComponent(null);
  };


  //----end filter--------------------
  return (
    <>

      { childComponent }
      <HeaderComponent headers={ pageConfig.headers } >
        <RefreshButton onClick={ getAllData } />
        <Search
          placeholder="Search something..."
          allowClear
          enterButton="Search"
          size="large"
          onChange={ (e) => setSearchKey(e.target.value) }
          onSearch={ (value) => setSearchKey(value) }
          style={ { width: 300 } }
        />
        <CreateButton onClick={ onCreate } />
      </HeaderComponent>
      <BodyComponent>
        <TableComponent
          loader={ loader }
          columns={ columns }
          dataSource={ filteredData }
          pagination={ true }
        />
      </BodyComponent>

    </>
  );
};

export default IndexTenants;

